import { inject, Injectable } from '@angular/core';
import { getDownloadURL, ref, Storage, uploadBytes } from '@angular/fire/storage';
import { TranslateService } from '@ngx-translate/core';
import { MarketModel } from 'src/app/models/market.model';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
// import QRCode from 'qrcode';
// const { QRCodeGenerator } = QRCode;

@Injectable(
  {providedIn: 'root'}
)
export class FileService {

  private storage: Storage = inject(Storage);


  rolePlural = {
    producer:'producers',
    consumer:'consumers',
    authority:'authorities'
  }

  constructor(public translateService:TranslateService) {
  }

  init(){
  }

  getProfilePhotoURL(item:ProfileModel,role:string){
    const fileRef = ref(this.storage,'/'+this.rolePlural[role]+'/'+item.key+'/details/shortDetails/photo-'+item.details.shortDetails.photoTimeStamp+'.jpg');
    return getDownloadURL(fileRef);
  }

  saveProfilePhoto(item:ProfileModel,file,role:string,timeStamp:string){
    const fileRef = ref(this.storage,'/'+this.rolePlural[role]+'/'+item.key+'/details/shortDetails/photo-'+timeStamp+'.jpg');
    return uploadBytes(fileRef,file);
  }
  
  getSalePhotoURL(item:TourneeModel){
    const fileRef = ref(this.storage,'/sales/'+item.key+'/details/photo-'+item.details.photoTimeStamp+'.jpg');
    return getDownloadURL(fileRef);
  }

  getMarketPhotoURL(item:TourneeModel){
    const fileRef = ref(this.storage,'/markets/'+item.key+'/details/photo-'+item.details.photoTimeStamp+'.jpg');
    return getDownloadURL(fileRef);
  }

  saveSalePhoto(item:TourneeModel,file,timeStamp:string){
    const fileRef = ref(this.storage,'/sales/'+item.key+'/details/photo-'+timeStamp+'.jpg');
    return uploadBytes(fileRef,file);
  }
  saveMarketPhoto(item:MarketModel,file,timeStamp:string){
    const fileRef = ref(this.storage,'/markets/'+item.key+'/details/photo-'+timeStamp+'.jpg');
    return uploadBytes(fileRef,file);
  }

  getProductPhotoURL(item:ProductModel){
    const fileRef = ref(this.storage,'/producers/'+item.producer.key+'/products/references/'+item.key+'/details/photo-'+item.details.photoTimeStamp+'.jpg');
    return getDownloadURL(fileRef);
  }

  saveProductPhoto(item:ProductModel,file,timeStamp:string){
    const fileRef = ref(this.storage,'/producers/'+item.producer.key+'/products/references/'+item.key+'/details/photo-'+timeStamp+'.jpg');
    return uploadBytes(fileRef,file);
  } 

  convertBlobToBase64(blob){
    return new Promise ((resolve,reject)=>{
      const reader = new FileReader;
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      }
      reader.readAsDataURL(blob);
    });
  }

  getBase64(file) {
    return new Promise((resolve,reject)=>{
    // const reader = new FileReader();
    // reader.readAsDataURL(file);
    // reader.onload = function () {
    //   resolve(reader.result);
    // };
    // reader.onerror = function (error) {
    //   reject(error);
    // };
    
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result);
      }
      reader.onerror = function (error) {
        reject(error);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', file);
    xhr.responseType = 'blob';
    xhr.send();
    })
  }
  getURLBySize(url: string,size:Number):string {
    let extension = '';
    if(url.includes('.png?')){
        extension = '.png';
    }
    else if(url.includes('.jpeg?')){
        extension = '.jpeg';
    }
    else if(url.includes('.jpg?')){
      extension = '.jpg';
    }
    const questionMarkPosition = url.indexOf(extension +'?');
    const endUrl = url.slice(questionMarkPosition);
    let newUrl = url.slice(0,questionMarkPosition);
    newUrl += ('_'+size+'x'+size);
    newUrl += endUrl;
    // console.log('url',url, newUrl, extension, endUrl,questionMarkPosition);
    return newUrl
  }

  generateQRCode(link:string){
    // error in package QRCode -> Can't find global variable
    //return QRCodeGenerator.toDataURL(link);
  }

  cutText(text,length){
    const pieces = []
    let trimmedString = text.slice(0, length);
    const position = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
    trimmedString = trimmedString.slice(0, position);
    pieces.push(trimmedString);
    const secondPart = text.slice(position+1,text.length-position);
    pieces.push(secondPart);
    return pieces;
  }

  getPhotoUrl(url: string,size:Number,type?:string) {
    const inAssets = url?url.includes('assets/'):false;
    if(url && !inAssets){
      let extension = '';
      if(url.includes('.png?')){
          extension = '.png';
      }
      else if(url.includes('.jpeg?')){
          extension = '.jpeg';
      }
      else if(url.includes('.jpg?')){
        extension = '.jpg';
      }
      const questionMarkPosition = url.indexOf(extension +'?');
      const endUrl = url.slice(questionMarkPosition);
      let newUrl = url.slice(0,questionMarkPosition);
      newUrl += ('_'+size+'x'+size);
      newUrl += endUrl;
      // console.log('url',url, newUrl, extension, endUrl,questionMarkPosition);
      return newUrl
    }
    else if (url && inAssets){
      return url;
    }
    else if (type){
      return 'assets/photos/'+type + '-small.jpg'
    }
    else return '';
  }
}
